(function() {
    'use strict';

    angular.module('format')
        .controller('FormatGroupUpdateController', FormatGroupUpdateController);

    FormatGroupUpdateController.$inject = ['$state', 'notificationSrvc', 'formatGroupDataSrvc', 'formatGroupMessagesConst', 'errorNotificationSrvc'];

    function FormatGroupUpdateController($state, notificationSrvc, formatGroupDataSrvc, formatGroupMessagesConst, errorNotificationSrvc) {
        var self = this;

        self.serverErrors = {
            name: [],
            name_de: [],
            name_en: [],
            name_cpde: [],
            name_cpen: [],
            nonFieldErrors: []
        };
        self.groupData = {
            nam_pl: null,
            name_de: null,
            name_en: null,
            name_cpde: null,
            name_cpen: null
        };

        self.updateGroup = updateGroup;
        self.cleanErrors = cleanErrors;

        activate();

        function activate() {
            getGroup();
        }

        function getGroup() {
            return formatGroupDataSrvc.get({
                pk: $state.params.pk
            }).$promise.then(function (response) {
                self.groupData = response;

                delete self.groupData.date_modified;
                delete self.groupData.date_added;
                return response;
            });
        }

        function updateGroup() {
            formatGroupDataSrvc.update({
                pk: self.groupData.pk
            }, self.groupData).$promise.then(
                function (response) {
                    notificationSrvc.notification("success", formatGroupMessagesConst.update);
                    $state.go('layout.formatGroup.list');
                },
                function (response) {
                    errorNotificationSrvc.displayErrors(response.data);
                    self.serverErrors = response.data;
                }
            );
        }

        function cleanErrors(key) {
            self.serverErrors[key] = [];
        }
    }
})();
